import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useEventListener } from "./useEventListener";

type AllowType = boolean | string | undefined | number;

export function useHistoryState<
  T extends AllowType | AllowType[] | Record<string | number, AllowType>,
>(id: string, state: T, onStateChange: (state: T) => void) {
  const history = useHistory<
    Record<string, { curr: T; prev?: T }> | undefined
  >();

  useEffect(() => {
    const currentState = history.location.state?.[id];

    if (currentState === undefined) {
      history.replace({
        state: { ...history.location.state, [id]: { curr: state } },
      });
    } else if (currentState.curr !== state) {
      if (currentState.prev !== state) {
        history.push({
          state: {
            ...history.location.state,
            [id]: { curr: state, prev: currentState.curr },
          },
        });
      } else {
        history.goBack();
      }
    }
  }, [id, state, history]);

  useEventListener("popstate", () => {
    const currentState = history.location.state?.[id];

    if (currentState && currentState.curr !== state) {
      history.replace({
        state: { ...history.location.state, [id]: { curr: currentState.curr } },
      });
      onStateChange(currentState.curr);
    }
  });
}
